// Customer-facing spend is shown INCLUSIVE of USF / local taxes / VoIP
// regulatory fees (~30%). This is a DISPLAY markup only — actual credit debits
// use the base usage rate (and still reconcile exactly). Keep the rate and the
// label here so every spend figure shown to a customer agrees.
export const USF_FEE_RATE = 0.3;

/** Base spend -> customer-facing spend including taxes & fees. */
export function withFees(amount: number): number {
  return amount * (1 + USF_FEE_RATE);
}

export const FEES_NOTE = "incl. taxes & fees";
